export default class SmoochIntegrationDouble {
  constructor() {
    this.onCallbacks = {};
  }

  login() {
    return {
      then: (onSuccess, onErr) => {
        this.onSuccess = onSuccess;
        this.onErr = onErr;

        onSuccess();
      },
    };
  }

  setDelegate() {}

  on(key, fn) {
    this.onCallbacks[key] = fn;
  }

  getUser() {
    return { _id: 'some-smooch-id' };
  }

  updateUser() {
    return new Promise(resolve => {
      resolve();
    });
  }

  getConversation() {
    return { _id: 'conversation_id', messages: [] };
  }

  sendMessage() {}

  startTyping() {}

  stopTyping() {}

  render() {}

  init() {
    return {
      then: function(callback) {
        // delay necessary for integration tests
        setTimeout(callback, 1000);
      },
    };
  }
}
